import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import MultiSelectField from "../Shared/MultiSelectField.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";
import BulkImportUDIs, { BulkImportUDIsIntro } from "./BulkImportUDIs.js";


const AddItemPopup = ({ globalContext }) => {

    const [selectedOption, setSelectedOption] = useState("single-product");

    const [addProductCode, setAddProductCode] = useState("");
    const [addProductName, setAddProductName] = useState("");
    const [addProductFamily, setAddProductFamily] = useState(null);
    const [addProductSPPP, setAddProductSPPP] = useState(null);
    const [addProductCountryOrigin, setAddProductCountryOrigin] = useState(null);
    const [addProductMadeIn, setAddProductMadeIn] = useState(null);
    const [addProductUDIDI, setAddProductUDIDI] = useState("");
    const [addProductLM, setAddProductLM] = useState(null);
    const [addProductPM, setAddProductPM] = useState(null);
    const [file, setFile] = useState(null);


    const [errorAddProductCode, setErrorAddProductCode] = useState("");
    const [errorAddProductName, setErrorAddProductName] = useState("");
    const [errorAddProductFamily, setErrorAddProductFamily] = useState(null);
    const [errorAddProductSPPP, setErrorAddProductSPPP] = useState(null);
    const [errorAddProductCountryOrigin, setErrorAddProductCountryOrigin] = useState(null);
    const [errorAddProductMadeIn, setErrorAddProductMadeIn] = useState(null);
    const [errorAddProductUDIDI, setErrorAddProductUDIDI] = useState(null);
    const [errorAddProductLM, setErrorAddProductLM] = useState(null);
    const [errorAddProductPM, setErrorAddProductPM] = useState(null);

    const [errorAddingProduct, setErrorAddingProduct] = useState(null);




    const [isAddingItem, setIsAddingItem] = useState(false);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);


    const [productFamilies, setProductFamilies] = useState([]);
    const [countries, setCountries] = useState([]);

    const [field_SPPP, setField_SPPP] = useState({});
    const [fieldConfig_SPPP, setFieldConfig_SPPP] = useState([]);
    const [formState_SPPP, setFormState_SPPP] = useState({});

    const [field_LM, setField_LM] = useState({});
    const [fieldConfig_LM, setFieldConfig_LM] = useState([]);
    const [formState_LM, setFormState_LM] = useState({});


    const [field_PM, setField_PM] = useState({});
    const [fieldConfig_PM, setFieldConfig_PM] = useState([]);
    const [formState_PM, setFormState_PM] = useState({});


    const dropdownRefs = useRef({});
    const pdfFileInputRef = useRef(null);

    const AppContext = globalContext;
    const allowedExtensions = ['.jpg', '.jpeg', '.gif', '.png', '.webp'];
    const maxUploadFiles = 1; // 0 for no limit
    



    const handleFileChange = (e) => {
        const selectedFile = e.target.files?.[0];

        if (!selectedFile) {
            return;
        }

        const allowedTypes = ["image/png", "image/jpeg"];

        if (!allowedTypes.includes(selectedFile.type)) {
            alert("Only PNG, JPG, and JPEG files are allowed.");
            e.target.value = "";
            setFile(null);
            return;
        }

        setFile(selectedFile);
    };


    const removeFile = () => {
        setFile(null);
    }


    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const addItem = () => {
        
        let isValidForm = true;

        setErrorAddProductCode(false);
        setErrorAddProductName(false);
        setErrorAddingProduct(null);

        if (!validFormField(addProductCode, setErrorAddProductCode))
            isValidForm = false;
        if (!validFormField(addProductName, setErrorAddProductName))
            isValidForm = false;
        
        if (!isValidForm) {
            setErrorAddingProduct("Product Code and Product Name can not be empty");
            return false;
        }


        const formData = new FormData();

        if (file)
            formData.append("File", file);

        formData.append("SKUProductCode", addProductCode);
        formData.append("ProductName", addProductName);
        formData.append("FamilyId", addProductFamily);
        formData.append("CountryOfOrigin", addProductCountryOrigin);
        formData.append("MadeIn", addProductMadeIn);
        formData.append("UDIDI", addProductUDIDI);
        //formData.append("LegalManufacturersIds", formState_LM["lm"]);
        //formData.append("PhysicalManufacturerIds", formState_PM["pm"]);
        //formData.append("SPPsIds", formState_SPPP["sppp"]);
        //formData.append("CustomFieldsAnswers", JSON.stringify(AppContext.newItemCustomFieldsAnswers));



        const appendToFormData = (formData, data, parentKey = "") => {
            // 1. Handle arrays (INCLUDING empty arrays)
            if (Array.isArray(data)) {
                if (data.length === 0) {
                    // IMPORTANT: preserve empty array explicitly
                    formData.append(parentKey, JSON.stringify([]));
                    return;
                }

                data.forEach((item, index) => {
                    appendToFormData(formData, item, `${parentKey}[${index}]`);
                });

                return;
            }

            // 2. Handle objects
            if (typeof data === "object" && data !== null) {
                Object.keys(data).forEach((key) => {
                    const fullKey = parentKey ? `${parentKey}.${key}` : key;
                    appendToFormData(formData, data[key], fullKey);
                });
                return;
            }

            // 3. Primitive values (including null/undefined safety)
            formData.append(parentKey, data ?? "");
        };


        appendToFormData(formData, { "LegalManufacturersIds": formState_LM["lm"] });
        appendToFormData(formData, { "PhysicalManufacturerIds": formState_PM["pm"] });
        appendToFormData(formData, { "SPPsIds": formState_SPPP["sppp"] });
        appendToFormData(formData, { "CustomFieldsAnswers": AppContext.newItemCustomFieldsAnswers });


        setIsAddingItem(true);

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            body: formData
        };



        
        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {

                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingProduct(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }



    const loadSPPPs = (preserveSelection = false) => {

        let url = "/umbraco/api/RIMSProducts/Operators?roleId=9";

        let requestOptions = {};
        
        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let field_sppp = {
                    Alias: "sppp",
                    Name: "System or Procedure Pack Producer (SPPP)",
                    Items: []
                };

                field_sppp.Items = data.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));


                setField_SPPP(field_sppp);
                setFieldConfig_SPPP([field_sppp]);
                if (!preserveSelection)
                    setFormState_SPPP({ sppp: [] });

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });



    }


    const loadLegalManufacturers = (preserveSelection = false) => {

        let url = "/umbraco/api/RIMSProducts/Operators?roleId=1";

        let requestOptions = {};
        
        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                
                let field_lm = {
                    Alias: "lm",
                    Name: "Legal Manufacturer",
                    Items: []
                };

                field_lm.Items = data.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_LM(field_lm);
                setFieldConfig_LM([field_lm]);
                if (!preserveSelection)
                    setFormState_LM({ lm: [] });

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }


    const loadPhysicalManufacturers = (preserveSelection = false) => {


        let url = "/umbraco/api/RIMSProducts/Operators?roleId=5";

        let requestOptions = {};
        
        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let field_pm = {
                    Alias: "pm",
                    Name: "Physical Manufacturer",
                    Items: []
                };

                field_pm.Items = data.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_PM(field_pm);
                setFieldConfig_PM([field_pm]);
                if (!preserveSelection)
                    setFormState_PM({ pm: [] });

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });



        


    }


    const loadProductFamilies = () => {


        let url = "/umbraco/api/RIMSProducts/Families";

        let requestOptions = {};
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let families = data.map(family => ({ id: family.Id, name: family.Name }));

                families.sort((a, b) => a.name.localeCompare(b.name));
                

                let NA = { id: 0, name: "N/A" };

                families = [NA, ...families];

                setProductFamilies(families);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });
    }


    const loadCountries = () => {
        
        let url = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {};
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let countries = data.map(country => ({ id: country.CountryId, name: country.CountryName }));

                countries.sort((a, b) => a.name.localeCompare(b.name));

                let NA = { id: 0, name: "N/A" };

                countries = [NA, ...countries];

                setCountries(countries);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });
    }



    useEffect(() => {

        // SPPP field

        loadSPPPs();

        // Legal manufacturer field

        loadLegalManufacturers();

        // Physical manufacturer field

        loadPhysicalManufacturers();



        loadProductFamilies();

        loadCountries();


    }, []);






    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}s</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>




            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: "15px",
                    marginTop: "10px"
                }}>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "single-product"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("single-product")}
                >
                    <i className="fas fa-box-open g-mr-5"></i> Add Product
                </div>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "bulk-products"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("bulk-products")}
                >
                    <i className="fa fa-upload g-mr-5"></i> Import Products
                </div>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "udis"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("udis")}
                >
                    <i className="fas fa-file-alt g-mr-5"></i> Bulk UDI Upload
                </div>

                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

            </div>




            <div style={{ marginTop: "20px" }}>


                {selectedOption == "single-product" ?
                    <div style={{ paddingTop: "10px", }}>


                        <div>

                            <div style={{ width: "100%" }}>
                                Product Code *
                                <br />
                                <input className={`form-field-text add-task-field-name ${errorAddProductCode ? " form-field-error" : null}`}
                                    value={addProductCode}
                                    onChange={(e) => setAddProductCode(e.target.value)}
                                    style={{ width: "100%" }} type="text" placeholder="" />

                                {errorAddProductCode && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}

                            </div>

                            <br />


                            <div style={{ width: "100%" }}>
                                Product Name *
                                <br />
                                <input className={`form-field-text add-task-field-name ${errorAddProductName ? " form-field-error" : null}`}
                                    value={addProductName}
                                    onChange={(e) => setAddProductName(e.target.value)}
                                    style={{ width: "100%" }} type="text" placeholder="" />

                                {errorAddProductName && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}
                            </div>

                            <br />


                            <div style={{ width: "100%" }}>
                                Product Family
                                <br />
                                <select
                                    value={addProductFamily}
                                    onChange={(e) => setAddProductFamily(e.target.value)}
                                >
                                    {productFamilies.map((pf, index) => (
                                        <option key={index} value={pf.id}>{pf.name}</option>
                                    ))}
                                </select>
                            </div>

                            <br />

                            <div style={{ width: "100%" }}>
                                UDI-DI i.e. GTIN
                                <br />
                                <input className={`form-field-text add-task-field-name ${errorAddProductUDIDI ? " form-field-error" : null}`}
                                    value={addProductUDIDI}
                                    onChange={(e) => setAddProductUDIDI(e.target.value)}
                                    style={{ width: "100%" }} type="text" placeholder="" />
                            </div>

                            <br />

                            <SearchableCountrySelect
                                label="Country of Origin"
                                value={addProductCountryOrigin}
                                onChange={setAddProductCountryOrigin}
                                countries={countries}
                            />

                            <br />


                            <SearchableCountrySelect
                                label="Made In"
                                value={addProductMadeIn}
                                onChange={setAddProductMadeIn}
                                countries={countries}
                            />

                            <br />



                            

                            <div style={{ width: "100%" }}>

                                <MultiSelectField
                                    field={field_LM}
                                    formState={formState_LM}
                                    setFormState={setFormState_LM}
                                    fieldsConfig={fieldConfig_LM}
                                    searchValues={searchValues}
                                    setSearchValues={setSearchValues}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownRefs={dropdownRefs}
                                    noneIsAll={false}
                                    allowAddOperator={true}
                                    operatorRoleId={1}
                                    onRefreshOperators={() => loadLegalManufacturers(true)}
                                />

                            </div>

                            <br />



                            <div style={{ width: "100%" }}>

                                <MultiSelectField
                                    field={field_PM}
                                    formState={formState_PM}
                                    setFormState={setFormState_PM}
                                    fieldsConfig={fieldConfig_PM}
                                    searchValues={searchValues}
                                    setSearchValues={setSearchValues}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownRefs={dropdownRefs}
                                    noneIsAll={false}
                                    allowAddOperator={true}
                                    operatorRoleId={5}
                                    onRefreshOperators={() => loadPhysicalManufacturers(true)}
                                />

                            </div>

                            <br />

                            <div style={{ width: "100%" }}>

                                <MultiSelectField
                                    field={field_SPPP}
                                    formState={formState_SPPP}
                                    setFormState={setFormState_SPPP}
                                    fieldsConfig={fieldConfig_SPPP}
                                    searchValues={searchValues}
                                    setSearchValues={setSearchValues}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownRefs={dropdownRefs}
                                    noneIsAll={false}
                                    allowAddOperator={true}
                                    operatorRoleId={9}
                                    onRefreshOperators={() => loadSPPPs(true)}
                                />

                            </div>

                            <br />


                            {/* CUSTOM FIELDS */}
                            {AppContext.enableCustomFields ? 
                                <AddItemCustomFields entityType={0} context={AppContext} />
                            : null}

                            <div style={{ width: "100%" }}>

                                Product Image
                                <br />

                                <div style={{ marginTop: "5px" }}>
                                    {file == null ?
                                        <>
                                            <label
                                                style={{ width: "200px", textAlign: "center", marginBottom: "20px", cursor: "pointer", fontSize: "1.1em", padding: "4px 15px", backgroundColor: "", border: "1px solid black", borderRadius: "15px" }}
                                                id="file-input-label"
                                                onClick={() => pdfFileInputRef.current.click()}
                                            >
                                                Select the product image
                                            </label>


                                            <input
                                                id="file-input"
                                                type="file"
                                                title=""
                                                multiple={false}
                                                ref={pdfFileInputRef}
                                                onChange={handleFileChange}
                                                style={{ display: "none" }}
                                                accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                                            />
                                        </>
                                        :
                                        <div style={{
                                            display: "flex", flexDirection: "row", padding: "5px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#eee",
                                        }}>
                                            <div style={{ fontSize: "9pt" }}>
                                                {file.name}
                                            </div>
                                            <div style={{ width: "20%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <i title="Remove file" onClick={removeFile} className="pointer circle-delete-button fas fa-times-circle"></i>
                                            </div>
                                        </div>
                                    }
                                </div>


                            </div>

                            <br />

                            {/* BUTTONS */}

                            <div className="action-button-bar">

                                <div className="action-button-bar-left">
                                    <button
                                        className="action-button cancel-button"
                                        onClick={() => AppContext.showAddItemPopup(false)}
                                    >
                                        Close
                                    </button>
                                </div>

                                <div className="action-button-bar-center">

                                    {errorAddingProduct ? <div style={{color: "#ff5400"}}>Error: {errorAddingProduct}</div> : null }

                                </div>

                                <div className="action-button-bar-right">
                                    {isAddingItem ? (
                                        <LoadingSpinnerImage />
                                    ) : (
                                        <>

                                            {
                                                AppContext.reachedAllowanceProductsOnly ?
                                                    <span>
                                                        <span className="action-button add-task-button" style={{ backgroundColor: "#c0c0c0", cursor: "help" }} title="Allowance limit reached. Contact MedBoard to increase the limit.">
                                                            <i className="fas fa-plus-circle g-mr-5"></i> Add Product
                                                        </span>
                                                    </span>
                                                    :
                                                    <button
                                                        className="action-button save-button"
                                                        onClick={addItem}
                                                    >
                                                        Add Product
                                                    </button>
                                            }

                                        </>

                                    )}
                                </div>
                            </div>


                        </div>

                    </div>

                : null}



                {selectedOption == "bulk-products" ?
                    <div style={{ paddingTop: "10px", textAlign: "center", paddingBottom: "30px" }}>
                        <div style={{ fontSize: "11px", textAlign: "left" }}>
                        <p>Use this option to automatically upload multiple products and related information using our MedBoard template for bulk upload. If you wish to use this option, please contact us and we will guide you to fill the form and evaluate your needs/data.</p>
                            <p>
                                NOTE: for data and software validation, please contact also MedBoard so we can ensure your data robustness and the uploaded information is good to go when starting to use this module officially.</p>

                                <p> Current Products Upload Template version: v2.0</p>
                        </div>

                        <BulkImportProducts AppContext={AppContext} />

                    </div>
                : null}


                {selectedOption == "udis" ?
                    <div style={{paddingTop: "10px", textAlign: "center", paddingBottom:"30px"}}>
                        <BulkImportUDIsIntro />
                        <BulkImportUDIs />

                    </div>
                : null}


            </div>


        </div>
    );
};





const SearchableCountrySelect = ({
    label,
    value,
    onChange,
    countries
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const selected = countries.find(c => c.id == value);

    const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={{ width: "100%", position: "relative" }}>
            {label}
            <br />

            <input
                type="text"
                value={isOpen ? search : (selected?.name || "")}
                placeholder="Search country..."
                onFocus={() => {
                    setIsOpen(true);
                    setSearch("");
                }}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setIsOpen(true);
                }}
                onBlur={() => {
                    setTimeout(() => setIsOpen(false), 150);
                }}
                style={{
                    width: "100%",
                    padding: "6px",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                }}
            />

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map(country => (
                            <div
                                key={country.id}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    onChange(country.id);
                                    setIsOpen(false);
                                    setSearch(country.name);
                                }}
                                style={{
                                    padding: "6px",
                                    cursor: "pointer"
                                }}
                            >
                                {country.name}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px", color: "#888" }}>
                            No results
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const BulkImportProducts = ({ AppContext }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [isDragging, setIsDragging] = useState(false); 

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setMessage(null);
        }
    };

    // --- Drag and Drop Handlers ---
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setFile(e.dataTransfer.files[0]);
            setMessage(null);
            e.dataTransfer.clearData();
        }
    };
    // ------------------------------

    const handleUpload = async () => {
        if (!file) {
            setMessage({ type: "error", text: "Please select a file first." });
            return;
        }

        setLoading(true);
        setMessage(null);

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch("/umbraco/api/RIMSProducts/BulkImportProducts", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || "Upload failed");
            }

            const result = await response.json().catch(() => null);

            setMessage({
                type: "success",
                text: result?.message || "File uploaded successfully.",
            });

            AppContext.loadData({ nextPage: false });

        } catch (err) {
            setMessage({
                type: "error",
                text: err.message || "Something went wrong.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                maxWidth: "400px",
                margin: "0 auto",
                padding: "24px",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fff",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)"
            }}
        >

            <label
                // Attach the drag and drop events here
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "30px 20px",
                    border: "2px dashed",
                    borderColor: isDragging ? "#3498db" : "#d1d5db",
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor: isDragging ? "#ebf5fb" : "#f9fafb",
                    transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => { if (!isDragging) e.currentTarget.style.borderColor = "#3498db"; }}
                onMouseOut={(e) => { if (!isDragging) e.currentTarget.style.borderColor = "#d1d5db"; }}
            >
                <i className="fas fa-upload" style={{ fontSize: "24px", color: isDragging ? "#3498db" : "#9ca3af", marginBottom: "8px" }}></i>
                <span style={{ textAlign: "center" }}>
                    {file ? file.name : "Click to select a file or drag and drop"}
                </span>
                <input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />
            </label>

            {/* Button */}
            {AppContext.reachedAllowanceProductsOnly ? (
                <span>
                    <span className="action-button add-task-button" style={{ backgroundColor: "#c0c0c0", cursor: "help" }} title="Allowance limit reached. Contact MedBoard to increase the limit.">
                        <i className="fas fa-arrow-up g-mr-5"></i> Upload products from Template
                    </span>
                </span>
            ) : (
                <button
                    onClick={handleUpload}
                    disabled={loading || !file}
                    type="submit"
                    className="btn u-btn-blue g-font-size-13 g-pl-12 g-pr-12 g-pt-8 g-pb-8"
                    style={{
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: loading || !file ? "not-allowed" : "pointer",
                        opacity: loading || !file ? 0.6 : 1,
                        border: "none",
                        width: "100%",
                        transition: "background 0.2s"
                    }}
                >
                    <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-arrow-up"}></i>
                    {loading ? "Uploading..." : "Upload products from Template"}
                </button>
            )}

            {/* Message */}
            {message && (
                <div
                    style={{
                        padding: "10px",
                        borderRadius: "6px",
                        background: message.type === "error" ? "#ffe5e5" : "#e6ffed",
                        color: message.type === "error" ? "#b30000" : "#1a7f37",
                        fontSize: "0.9rem"
                    }}
                >
                    {message.text}
                </div>
            )}
        </div>
    );
};












export default AddItemPopup;